import React from "react";
import StepTitle from "../../../../components/StepsTitle/StepTitle";
import {
    Alert,
    Avatar,
    Dropdown,
    ExclamationTriangleIcon,
    Flex,
    Input,
    InputLabel,
    Loader,
} from "@fluentui/react-northstar";
import CardContractDatesInfo from "../../../../components/Cards/CardContractDatesInfo/CardContractDatesInfo";
import TaskProcessus from "../../../../components/Badge/TaskProcessus";
import BadgeIcon from "../../../../components/BadgeIcon";
import {
    BuildingBank16Filled,
    PeopleTeam16Filled,
} from "@fluentui/react-icons";
import { Controller } from "react-hook-form";
import { ProfileJobTitle, ProfileUsername } from "./index.style";
import { ITEM_PERIOD_NOTICE } from "../../constants";
import FooterActionButtons from "../../components/footer/FooterActionButtons";
import useLogicStepDeparture from "../../hooks/useLogicStepDeparture";
import { ErrorMessage } from "../../../../common/styles";

const StepDeparture = () => {
    const { query, query_notice_period, form, mutation } =
        useLogicStepDeparture();

    return (
        <Flex fill column space="between" gap="gap.large">
            <Flex column gap="gap.large">
                <StepTitle title="Départ du collaborateur" step_number={1} />
                {/* PROFILE */}
                {/* PROFILE */}
                {/* PROFILE */}
                <Flex fill gap="gap.large">
                    <Flex fill column gap="gap.medium">
                        <Avatar
                            image={query.view.user.avatar}
                            name={query.view.user.full_name}
                            size="largest"
                        />
                        <Flex column gap="gap.small">
                            <Flex gap="gap.medium" vAlign="center">
                                <ProfileUsername
                                    content={query.view.user.full_name}
                                />
                                <TaskProcessus process_id={3} />
                            </Flex>
                            <Flex>
                                <ProfileJobTitle
                                    content={query.view.user.job_title}
                                />
                            </Flex>
                        </Flex>
                        <Flex gap="gap.medium">
                            <BadgeIcon
                                content={query.view.user.department}
                                icon={<PeopleTeam16Filled color="#616161" />}
                            />
                            <BadgeIcon
                                content={query.view.user.agency}
                                icon={<BuildingBank16Filled color="#616161" />}
                            />
                        </Flex>
                    </Flex>
                    <Flex fill>
                        <CardContractDatesInfo
                            isCDI={query.data?.contract?.name}
                            moment_end_contract={
                                query.view.contract.departure_date
                            }
                            moment_end_test_period={
                                query.view.contract.probationary_period_end_date
                            }
                            month_text={query.view.contract.month_text}
                            year={query.view.contract.year}
                            day_number={query.view.contract.day_number}
                            seniority_text={query.view.contract.seniority_text}
                            isMonthProBirthday={false}
                            can_update={false}
                            title={"Contrat"}
                            style={{
                                width: "100%",
                            }}
                        />
                    </Flex>
                </Flex>
                {/* Formulaire */}
                {/* Formulaire */}
                {/* Formulaire */}
                <form onSubmit={form.handleSubmit(form.onSubmit)}>
                    <Flex column gap="gap.large">
                        {/* dropdown */}
                        {query_notice_period.isLoading ? (
                            <Loader size="small" label="chargement .." />
                        ) : (
                            <Flex fill column>
                                <InputLabel
                                    content="Durée du préavis "
                                    required
                                />
                                <Controller
                                    control={form.control}
                                    name="notice_period_id"
                                    render={({
                                        field: { onChange, onBlur, value },
                                    }) => {
                                        return (
                                            <Dropdown
                                                items={
                                                    query_notice_period.formated_data
                                                }
                                                value={
                                                    query_notice_period.formated_data.find(
                                                        (el) =>
                                                            el?.id === value?.id
                                                    ) ||
                                                    query_notice_period.formated_data.at(
                                                        0
                                                    )
                                                }
                                                onChange={(_, i) => {
                                                    return onChange(i.value);
                                                }}
                                                error={
                                                    form.errors
                                                        ?.notice_period_id
                                                }
                                                onBlur={onBlur}
                                                inverted
                                                checkable
                                                fluid
                                                getA11ySelectionMessage={{
                                                    onAdd: (item) =>
                                                        `${item} has been selected.`,
                                                }}
                                                styles={{
                                                    width: "100%",
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </Flex>
                        )}
                        {/* date de départ  */}
                        <Flex column>
                            <Controller
                                control={form.control}
                                name="departure_date"
                                rules={form.rules.departure_date}
                                render={({ field: { onChange, value } }) => {
                                    return (
                                        <Input
                                            type="date"
                                            label="Date de départ "
                                            error={form.errors?.departure_date}
                                            value={value}
                                            onChange={(_, i) => {
                                                return onChange(i.value);
                                            }}
                                            required
                                            inverted
                                            fluid
                                        />
                                    );
                                }}
                            />
                            {form.errors.departure_date && (
                                <ErrorMessage
                                    content={form.errors.departure_date.message}
                                />
                            )}
                        </Flex>
                    </Flex>
                </form>
            </Flex>
            {/* FOOTER */}
            {/* FOOTER */}
            {/* FOOTER */}
            <FooterActionButtons
                onClickNextStep={(e) => {
                    e.preventDefault();
                    return form.handleSubmit(form.onSubmit)();
                }}
                enableButtonNextStep={form.isValid}
                enableButtonBackStep={false}
                isLoadingNextStep={mutation.isLoading}
            />
        </Flex>
    );
};

export default StepDeparture;
